import { Injectable } from '@angular/core';
import { SessionService } from '@ui-components/services';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private sessionService: SessionService) {}

  logout(): void {
    this.sessionService.logout();
  }
}
